import { render, staticRenderFns } from "./ScheduledOrderDetails.vue?vue&type=template&id=642341f2&scoped=true"
import script from "./ScheduledOrderDetails.vue?vue&type=script&lang=ts"
export * from "./ScheduledOrderDetails.vue?vue&type=script&lang=ts"
import style0 from "./ScheduledOrderDetails.vue?vue&type=style&index=0&id=642341f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642341f2",
  null
  
)

export default component.exports